const mapClinic = (c) => {
  var services = c.services
  if (typeof services === 'string') {
    try { services = JSON.parse(services) } catch { services = [] }
  }
  return {
    id: c.id,
    name: c.name,
    address: c.address,
    district: c.district,
    phone: c.phone,
    rating: c.rating || 0,
    reviews: c.reviews || 0,
    lat: c.lat,
    lng: c.lng,
    services: services || [],
    hours: c.hours,
    priceRange: c.price_range,
    logo: c.logo,
    website: c.website
  }
}

export const clinicsFetch = {
  from: 'clinics',
  params: { status: 'active' },
  order: { by: 'rating', asc: false },
  cache: '5m',
  transform: (data, el) => {
    const clinics = (data || []).map(mapClinic)
    const root = el.state.root || el.state
    if (root && root.update) root.update({ clinics, clinicsLoaded: true }, { preventFetch: true })
    return clinics
  }
}
